import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const StoreBillingIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M2.75 6C2.75 4.20507 4.20507 2.75 6 2.75H26C27.7949 2.75 29.25 4.20507 29.25 6V26C29.25 27.7949 27.7949 29.25 26 29.25H6C4.20507 29.25 2.75 27.7949 2.75 26V6Z"
          fill="white"
        />
        <path
          d="M11.5278 6H2.75C2.75002 4.34314 4.09317 3 5.75002 3H26.25C27.9069 3 29.25 4.34315 29.25 6H20.4722C19.3736 4.7725 17.777 4 16 4C14.223 4 12.6264 4.7725 11.5278 6Z"
          fill="#E4E0FF"
        />
        <path
          d="M2.75 26H29.25L29.25 26C29.25 27.6569 27.9069 29 26.25 29H5.75C4.09315 29 2.75 27.6569 2.75 26L2.75 26Z"
          fill="#C0AAFE"
        />
        <path
          d="M22.75 20.25C22.75 19.1454 21.8546 18.25 20.75 18.25H11.25C10.1454 18.25 9.25 19.1454 9.25 20.25V29.25H22.75V20.25Z"
          fill="#E4E0FF"
        />
        <path
          d="M14 22.875C14.3452 22.875 14.625 23.1548 14.625 23.5V25.25C14.625 25.5952 14.3452 25.875 14 25.875C13.6548 25.875 13.375 25.5952 13.375 25.25V23.5C13.375 23.1548 13.6548 22.875 14 22.875Z"
          fill="#0F3893"
        />
        <path
          d="M18.625 23.5C18.625 23.1548 18.3452 22.875 18 22.875C17.6548 22.875 17.375 23.1548 17.375 23.5V25.25C17.375 25.5952 17.6548 25.875 18 25.875C18.3452 25.875 18.625 25.5952 18.625 25.25V23.5Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 2C3.79086 2 2 3.79086 2 6V26C2 28.2091 3.79086 30 6 30H26C28.2091 30 30 28.2091 30 26V6C30 3.79086 28.2091 2 26 2H6ZM3.5 6C3.5 4.61929 4.61929 3.5 6 3.5H26C27.3807 3.5 28.5 4.61929 28.5 6V26C28.5 27.3807 27.3807 28.5 26 28.5H23.5V20.25C23.5 18.7312 22.2688 17.5 20.75 17.5H11.25C9.73122 17.5 8.5 18.7312 8.5 20.25V28.5H6C4.61929 28.5 3.5 27.3807 3.5 26V6ZM10 28.5H15.25V19H11.25C10.5596 19 10 19.5596 10 20.25V28.5ZM16.75 28.5H22V20.25C22 19.5596 21.4404 19 20.75 19H16.75V28.5Z"
          fill="#0F3893"
        />
        <path
          d="M20.3333 6.66667C20.3333 7.03486 20.0349 7.33333 19.6667 7.33333C19.2985 7.33333 19 7.03486 19 6.66667C19 6.29848 19.2985 6 19.6667 6C20.0349 6 20.3333 6.29848 20.3333 6.66667Z"
          fill="#006DFF"
        />
        <path
          d="M16 15C18.7614 15 21 12.7614 21 10C21 9.21608 20.8196 8.47429 20.498 7.81389C20.2646 7.98335 19.9773 8.08327 19.6668 8.08327C18.8844 8.08327 18.2501 7.44901 18.2501 6.66661C18.2501 6.30776 18.3835 5.98007 18.6035 5.73045C17.8452 5.26705 16.9538 5 16 5C13.2386 5 11 7.23858 11 10C11 12.7614 13.2386 15 16 15Z"
          fill="#006DFF"
        />
      </svg>
    );
  }
);
export default StoreBillingIcon;
